import { combineReducers } from "@reduxjs/toolkit";
import order from "./orderSlice";
import draftOrder from "./draftOrderSlice";
import checkout from "./checkoutSlice";
import groupReturn from "./groupReturnSlice";
import pendingOrderList from "./pendingOrderSlice";
import cancelOrder from "./cancelOrderSlice";
import pickingTicket from "./pickingTicketSlice";
import usOrder from "./usOrderSlice";
import restockReport from "./restockReportSlice";
import returnOrder from "./returnOrderSlice";
import tracking from "./trackingSlice";

const orderReducer = combineReducers({
  order,
  draftOrder,
  checkout,
  groupReturn,
  pendingOrderList,
  cancelOrder,
  pickingTicket,
  usOrder,
  restockReport,
  returnOrder,
  tracking,
});

export default orderReducer;
